import AxiosConfig from "../../../config/AxiosConfigJs";
import { DriveRouteInfo } from "./Model/DriveRouteInfo";
import { DriveStyle } from "./Model/DriveStyle";

/// <summary>
/// 驾车服务
/// </summary>
export class DriveService {

	constructor() {
		this.destLat = -1;
		this.destLon = -1;
		this.origLat = -1;
		this.origLon = -1;
		this.style = DriveStyle.LeastTime;
		this.tdtURL = "http://api.tianditu.gov.cn/drive";
		this.token = null;
		//途经点，格式类似：117.11912,36.67688;117.17984,36.679592
		this.mid="";
	}

	/**
	 * 获取驾车信息
	 * @param {*} succeedCallback 
	 * @param {*} errorCallback 
	 */
	Drive(succeedCallback, errorCallback) {

		let postString = "{\"orig\":\"" + this.origLon + "," + this.origLat + "\",\"dest\":\"" + this.destLon + "," + this.destLat + "\",\"style\":\"" + this.style + "\",\"mid\":\"" + this.mid + "\"}";
		
		AxiosConfig.nationalTDTConfig
			.get(this.tdtURL, { params: { random: Math.random(), postStr: postString, type: "search", tk: this.token } })
			.then(function (response) {
				if (response != null) {
					let resultObj = response.data;
					let curInfo = DriveRouteInfo.GetDriveRouteInfo(resultObj);
					if (succeedCallback) {
						succeedCallback(curInfo);
					}
				}
			})

			.catch(function (error) {
				if (errorCallback) {
					errorCallback(error.message);
				}
			});
	}

	/**
	 * 测试用
	 */
	static test() {
		let drive = new DriveService();
		drive.destLat = 39.90854;
		drive.destLon = 116.39751;
		drive.origLat = 39.92277;
		drive.origLon = 116.35506;
		drive.token = "ebddfc3f34215c7375bddd93f03dd684";
		drive.Drive(null, null);
	}


}//end DriveService

